module.exports = __webpack_public_path__ + "img/payment_process_no.d414e33.png";